import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CompanyService, ICompanyReturn } from '../../core/company/company.service';

const SERVER_PATH = import.meta.env.NG_APP_API_URL;

@Injectable({
  providedIn: 'root',
})
export class UploadImageService {
  http = inject(HttpClient);
  companyService = inject(CompanyService);

  postImg(file: File) {
    const bizId = this.companyService.getBizState();
    const compId = (this.companyService.getCompanyState() as ICompanyReturn)?.id;
    const fileParams = new FormData();
    fileParams.append('file', file);
    return this.http.post(
      `${SERVER_PATH}/upload/image?businessId=${bizId}${compId ? `&compId=${compId}` : ''}`,
      fileParams
    );
  }

  // /upload/image
}
